<template>
  <div id="app">
    <transition name="slide" mode="out-in">
        <router-view></router-view>
    </transition>
    <div v-if="development">
      <button v-if="!showbtns" @click="showbtns = true" style="position: absolute; bottom: 0px; left: 0px;">Show devtools</button>
      <div v-if="showbtns">
        <br><br><br>
        <div class="well">
          <button class="pull-right" v-if="showbtns" @click="showbtns = false">Hide</button>
          <h4>Development tools</h4>
          <div class="row">
            <h5>Task state:</h5>
            <button class="btn btn-default" @click="updateCurrentTaskStatus('clean')">Clean</button>
            <button class="btn btn-default" @click="updateCurrentTaskStatus('started')">Started</button>
            <button class="btn btn-default" @click="updateCurrentTaskStatus('completed')">Complete</button>
            <button class="btn btn-default" @click="updateCurrentTaskStatus('aborted')">Aborted</button>
          </div>
          <div class="row">
            <h5>Context state</h5>
            <button class="btn btn-default" @click="updateCurrentContext('done')">Done</button>
            <button class="btn btn-default" @click="updateCurrentContext('consent')">Consent</button>
            <button class="btn btn-default" @click="updateCurrentContext('task')">Task</button>
            <button class="btn btn-default" @click="updateCurrentContext('feedback')">Feedback</button>
          </div>
          <div class="row">
            <h5>Task part</h5>
            <button class="btn btn-default" @click="updateCurrentTaskComponent('instruction')">Instruction</button>
            <button class="btn btn-default" @click="updateCurrentTaskComponent('training')">Training</button>
            <button class="btn btn-default" @click="updateCurrentTaskComponent('trainingcompleted')">Training Completed</button>
            <button class="btn btn-default" @click="updateCurrentTaskComponent('test')">Test</button>
            <button class="btn btn-default" @click="updateCurrentTaskComponent('recall')">Recall</button>
            <button class="btn btn-default" @click="updateCurrentTaskComponent('delayed')">Delayed</button>
            <button class="btn btn-default" @click="updateCurrentTaskComponent('recognition')">Recognition</button>
            <button class="btn btn-default" @click="updateCurrentTaskComponent('testcompleted')">Test Completed</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import log from './lib/logger'

export default {
  name: 'app',
  data () {
    return {
      development: false,
      showbtns: false
    }
  },
  methods: {
    ...mapActions({
      changeTask: 'changeTask',
      changeComponent: 'changeTaskComponent',
      updateTask: 'updateTask',
      updateCurrentContext: 'updateCurrentContext',
      updateCurrentTaskStatus: 'updateCurrentTaskStatus',
      updateCurrentTaskComponent: 'updateCurrentTaskComponent'
    }),
    changeTaskComponent (component) {
      this.changeComponent(component)
    }
  },
  created () {
    log.info('[Memoro] - Welcome to Memoro!')
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
}

.alert-pad {
  padding: 2px 8px;
}
.lifted {
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
}

.slide-enter-active {
    animation: slide-in 400ms ease-out forwards;
}

.slide-leave-active {
    animation: slide-out 400ms ease-out forwards;
}

@keyframes slide-in {
    from {
        transform: translateY(-30px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
        opacity: 1;
    }
    to {
        transform: translateY(-30px);
        opacity: 0;
    }
}

.form-signin
{
    max-width: 330px;
    padding: 15px;
    margin: 0 auto;
}
.form-signin .form-signin-heading, .form-signin .checkbox
{
    margin-bottom: 10px;
}
.form-signin .checkbox
{
    font-weight: normal;
}
.form-signin .form-control
{
    position: relative;
    font-size: 16px;
    height: auto;
    padding: 10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
.form-signin .form-control:focus
{
    z-index: 2;
}
.form-signin input[type="text"]
{
    margin-bottom: -1px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
.form-signin input[type="password"]
{
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.account-wall
{
    margin-top: 20px;
    padding: 10px 0px 20px 0px;
    background-color: #fcfcfc;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}
.login-title
{
    color: #555;
    font-size: 18px;
    font-weight: 400;
    display: block;
}
.profile-img
{
    width: 96px;
    height: 96px;
    margin: 0 auto 10px;
    display: block;
    -moz-border-radius: 50%;
    -webkit-border-radius: 50%;
    border-radius: 50%;
}
.need-help
{
    margin-top: 10px;
}
.new-account
{
    display: block;
    margin-top: 10px;
}
.vue-keyboard {
  margin: 20px 0;
}

.vue-keyboard button {
  padding: 20px 30px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.instruction {
  margin-top: 10px;
  font-size: 18px;
}
.training {
  margin-top: 10px;
  font-size: 18px;
}
.completedTraining {
  margin-top: 10px;
  font-size: 18px;
}
#panelContainer {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// App.vue?0ce1af28